import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddDigitalCardComponent } from '@app/features/digital-cards/add-digital-card/add-digital-card.component';
import { ViewDigitalCardComponent } from '@app/features/digital-cards/view-digital-card/view-digital-card.component';

const routes: Routes = [
  { path: '', component: AddDigitalCardComponent },
  { path: 'add', component: AddDigitalCardComponent },
  { path: ':digitalCardId', component: ViewDigitalCardComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DigitalCardsRoutingModule { }
